module.exports = __webpack_public_path__ + "img/filter-square-fill.072a66e0.svg";